import "./documentRow.scss";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { qilloIconMap } from "../../utils/iconMapping";
import newRequest from "../../utils/newRequest";
import { ScaleLoader } from "react-spinners";
import { GoHomeFill } from "react-icons/go";
import { FiSearch } from "react-icons/fi";
import { MdClose } from "react-icons/md";


const MobileMenu = () => {
    const { t } = useTranslation();
    const { currentUser } = useSelector((state) => state.user);
    const [isLoading, setIsLoading] = useState(false);
    const [favMenus, setFavMenus] = useState([]);
    const [selectedFavMenu, setSelectedFavMenu] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const navigate = useNavigate();
    const location = useLocation();

    const fetchFavouriteMenus = async () => {
        setIsLoading(true);
        try {
            const res = await newRequest.get("/adUserRole/mobile");
            setFavMenus(res.data);
        } catch (err) {
            console.log(err);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (currentUser) fetchFavouriteMenus();
    }, [currentUser]);

    // Filter menus by search term
    const filteredRoles = favMenus?.map((role) => ({
        ...role,
        menus: role.menus.filter((menu) =>
            menu.menu_name.toLowerCase().includes(searchTerm.toLowerCase())
        ),
    })).filter((role) => role.menus.length > 0);

    return (
        <motion.div
            className="document-row"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1 } }}
            exit={{ opacity: 0, transition: { duration: 1 } }}
        >
            {isLoading ? (
                <div className="no-content">
                    <ScaleLoader color="#F44336" height={50} radius={8} width={4} />
                </div>
            ) : (
                favMenus?.length > 0 ? (
                    <div className="fav-menu-wrapper-container">
                        {/* 🔍 Search bar */}
                        {/* <div style={{ width: "100%", padding: "10px" }}>
                            <input
                                type="text"
                                placeholder="Search menus..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    borderRadius: "8px",
                                    border: "1px solid #ccc",
                                    outline: "none"
                                }}
                            />
                        </div> */}

                        <div className="search-input-wrapper" style={{ width: "100%", padding: "10px" }}>
                            <FiSearch className="search-input-icon" />
                            <input
                                className="search-input"
                                type="text"
                                placeholder={`${t('search')} ${t('menus')}...`}
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            {searchTerm.length > 0 && (
                                <MdClose
                                    onClick={(e) => setSearchTerm("")}
                                    className="search-input-icon"
                                />
                            )}
                            {searchTerm?.length === 0 && (
                                <span className="search-input-icon" />
                            )}
                        </div>

                        {filteredRoles.map((role) => (
                            <div key={role.role_docid} className="role-section">
                                {/* Role title */}
                                <h3 className="sub-title"
                                    style={{
                                        margin: "15px 10px 5px",
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                    }}>
                                    {role.role_name} [{role.role_code}]
                                </h3>

                                {/* Menus under role */}
                                <div className="fav-menu-wrapper">
                                    {role.menus.map((menu, index) => {
                                        const IconComponent =
                                            qilloIconMap[menu?.menu_icon] || GoHomeFill;
                                        return (
                                            <div
                                                key={menu?._id}
                                                className={`${selectedFavMenu?._id === menu?._id
                                                    ? "sub-menu-item current"
                                                    : "sub-menu-item"
                                                    }`}
                                                onClick={async () => {
                                                    setSelectedFavMenu(menu);
                                                    const path = `/${menu?.menu_function?.replace(/^\/+/, "")}`;
                                                    navigate(path, {
                                                        replace: true,
                                                        state: {
                                                            showBack: "Y",
                                                            menuDocid: menu?._id,
                                                            favMenu: "Y",
                                                        },
                                                    });
                                                }}
                                            >
                                                <IconComponent className="sub-menu-icon" />
                                                <div className="sub-menu-content">
                                                    <div className="sub-menu-name">
                                                        {menu?.menu_name}
                                                    </div>
                                                    <div className="sub-menu-description">
                                                        {menu?.menu_function}
                                                    </div>
                                                </div>
                                                <div style={{ display: "flex", flexDirection: "row", gap: "5px" }}>
                                                    <span className="sub-title">{index + 1}</span>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="no-content-wrapper">
                        <span className="main-title">
                            no menu found
                        </span>
                    </div>
                )
            )}
        </motion.div>
    );
};

export default MobileMenu;